import { type ContactListInput } from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const contactListKey = (props?: ContactListInput): QueryKey => {
  if (!props) return ['contacts']
  return ['contacts', props]
}
export const contactInfiniteKey = (props?: ContactListInput): QueryKey => {
  if (!props) return ['contacts-infinite']
  return ['contacts-infinite', props]
}
